import React, { useState, useEffect } from "react";
import { toJpeg } from "html-to-image";
import QRCode from "qrcode.react";

const QRCodeGenerator = () => {
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    // Get the current page URL
    setCurrentUrl(window.location.href);
  }, []);

  const downloadQrCode = () => {
    const qrCodeElement = document.getElementById("qr-code");
    if (qrCodeElement) {
      toJpeg(qrCodeElement)
        .then((dataUrl: string) => {
          const link = document.createElement("a");
          link.download = "qr-code.jpeg";
          link.href = dataUrl;
          link.click();
        })
        .catch((error: any) => {
          console.error("Error generating JPEG:", error);
        });
    }
  };

  return (
    <div>
      <h4>QR Code Generator</h4>
      <div id="qr-code-container" style={{ textAlign: "center" }}>
        {/* Display the current URL as a label */}
        <div style={{ marginBottom: "10px", fontSize: "16px", fontWeight: "bold" }}>
          {currentUrl}
        </div>
        {/* QR Code */}
        <div id="qr-code">
          <QRCode value={currentUrl} size={256} />
        </div>
      </div>
      <br />
      <button type="button" onClick={downloadQrCode}>
        Download QR Code as JPEG
      </button>
    </div>
  );
};

export default QRCodeGenerator;